import { useEffect, useMemo } from 'react';
import type { ShellApplicationClassificationFilter } from './application-classification';
import { buildClassificationFilterModel } from './application-classification';
import { useApplicationClassificationFilter } from './application-classification-context';
import { useWorkspaceApplications } from './workspace-applications';

export function useVisibleAppsByClassification() {
  const workspaceApplications = useWorkspaceApplications();
  const { selectedClassification, setSelectedClassification } = useApplicationClassificationFilter();

  const model = useMemo(
    () => buildClassificationFilterModel(workspaceApplications.applications, selectedClassification),
    [workspaceApplications.applications, selectedClassification],
  );

  useEffect(() => {
    if (model.selectedClassification !== selectedClassification) {
      setSelectedClassification(model.selectedClassification);
    }
  }, [model.selectedClassification, selectedClassification, setSelectedClassification]);

  return {
    ...workspaceApplications,
    accessibleApplications: model.accessibleApplications,
    filteredApplications: model.filteredApplications,
    classificationOptions: model.options,
    visibleClassifications: model.visibleClassifications,
    selectedClassification: model.selectedClassification,
    shouldShowClassificationBar: model.shouldShowClassificationBar,
    selectClassification(classification: ShellApplicationClassificationFilter) {
      setSelectedClassification(classification);
    },
  };
}
